export interface CategoryData {
    id: string;
    title: string;
    backgroundColor: string;
    url: string;
    // Propiedades para el diseño antiguo (opcionales)
    mainImage?: string;
    mainImageAlt?: string;
    mainImageWidth?: number;
    mainImageHeight?: number;
    mainImagePosition?: {
      x?: string;
      y?: string;
    };
    decorativeImages?: Array<{
      src: string;
      alt: string;
      width: number;
      height: number;
      className: string;
    }>;
    // Propiedades para el nuevo diseño (opcionales)
    backgroundImage?: string;
    backgroundImageAlt?: string;
  }
  

export const defaultCategories: CategoryData[] = [
  {
    id: 'pasta',
    title: 'PASTA',
    backgroundColor: 'bg-slider-9',
    url: '/la-despensa-italiana/pastas',
    mainImage: '/images/img_motivopasta_2.png',
    mainImageAlt: 'Pasta',
    mainImageWidth: 110,
    mainImageHeight: 180,
    mainImagePosition: {
      x: 'left-1/2 -translate-x-1/2',
      y: 'top-1/2 -translate-y-1/2'
    },
    decorativeImages: [
      {
        src: '/images/img_mododeaislamiento.svg',
        alt: '',
        width: 81,
        height: 62,
        className: 'absolute top-8 right-2 z-2'
      },
      {
        src: '/images/img_frame.svg',
        alt: '',
        width: 96,
        height: 85,
        className: 'absolute top-6 left-0'
      }
    ]
  },
  {
    id: 'quesos',
    title: 'QUESOS',
    backgroundColor: 'bg-slider-3',
    url: '/alimentos-frescos/queso',
    mainImage: '/images/img_queso_1.png',
    mainImageAlt: 'Quesos',
    mainImageWidth: 150,
    mainImageHeight: 180,
    mainImagePosition: {
      x: 'left-1/2 -translate-x-1/2',
      y: 'top-1/2 -translate-y-1/2'
    },
    decorativeImages: [
      {
        src: '/images/img_mododeaislamiento_lime_900.svg',
        alt: '',
        width: 90,
        height: 95,
        className: 'absolute bottom-5 left-5'
      },
      {
        src: '/images/img_mododeaislamiento_lime_900_48x105.svg',
        alt: '',
        width: 108,
        height: 105,
        className: 'absolute top-12 right-0'
      }
    ]
  },
  {
    id: 'zumos',
    title: 'ZUMOS INFANTILES',
    backgroundColor: 'bg-slider-5',
    url: '/alimentos-infantiles/zumos-infantiles',
    mainImage: '/images/img_zumo_1.png',
    mainImageAlt: 'Zumos',
    mainImageWidth: 120,
    mainImageHeight: 130,
    decorativeImages: [
      {
        src: '/images/img_1.svg',
        alt: '',
        width: 110,
        height: 103,
        className: 'absolute bottom-0 left-0'
      }
    ]
  },
  {
    id: 'vinos',
    title: 'VINOS',
    backgroundColor: 'bg-slider-1',
    url: '/bebidas/vino',
    mainImage: '/images/img_motivobebidas_1.png',
    mainImageAlt: 'Vinos',
    mainImageWidth: 150,
    mainImageHeight: 180,
    mainImagePosition: {
      x: 'left-1/2 -translate-x-1/2',
      y: 'top-1/2 -translate-y-1/2'
    },
    decorativeImages: [
      {
        src: '/images/img_capa_1.svg',
        alt: '',
        width: 60,
        height: 47,
        className: 'absolute bottom-4 right-2 filter brightness-50'
      },
      {
        src: '/images/img_frame_black_900_176x107.svg',
        alt: '',
        width: 110,
        height: 73,
        className: 'absolute top-2 right-2 filter brightness-50'
      },
      {
        src: '/images/img_capa_1_black_900.svg',
        alt: '',
        width: 40,
        height: 32,
        className: 'absolute bottom-12 left-3 filter brightness-50'
      }
    ]
  },
  {
    id: 'cabello',
    title: 'PRODUCTOS\nPARA EL CABELLO',
    backgroundColor: 'bg-slider-8',
    url: '/cuidado-personal/productos-para-el-cabello',
    mainImage: '/images/img_bote2_1.png',
    mainImageAlt: 'Productos para el cabello',
    mainImageWidth: 120,
    mainImageHeight: 130,
    mainImagePosition: {
      x: 'left-1/3 -translate-x-1/2',
      y: 'top-2/3 -translate-y-1/2'
    },
    decorativeImages: [
      {
        src: '/images/img_mododeaislamiento_red_300.svg',
        alt: '',
        width: 94,
        height: 91,
        className: 'absolute bottom-6 right-6'
      },
      {
        src: '/images/img_mododeaislamiento_red_300_66x67.svg',
        alt: '',
        width: 66,
        height: 67,
        className: 'absolute bottom-10 left-8'
      },
      {
        src: '/images/img_bote1_1.png',
        alt: 'Producto 1',
        width: 91,
        height: 86,
        className: 'absolute bottom-12 right-10'
      }
    ]
  },
  {
    id: 'cocina',
    title: 'PRODUCTOS COCINA',
    backgroundColor: 'bg-slider-7',
    url: '/cuidado-personal/productos-para-el-cabello',
    mainImage: '/images/img_rollin_1.png',
    mainImageAlt: 'Productos cocina',
    mainImageWidth: 170,
    mainImageHeight: 180,
    mainImagePosition: {
      x: 'left-1/2 -translate-x-1/2',
      y: 'top-1/2 -translate-y-1/2'
    },
    decorativeImages: [
      {
        src: '/images/img_mododeaislamiento_lime_900_01.svg',
        alt: '',
        width: 151,
        height: 148,
        className: 'absolute top-10 left-5'
      }
    ]
  }
];

// Categorías recomendadas hardcodeadas (sección home - desktop y mobile)
export const recommendedCategories: CategoryData[] = [
  {
    id: 'cat-pastas',
    title: 'PASTAS',
    backgroundColor: 'bg-gray-200',
    url: '/la-despensa-italiana/pastas',
    backgroundImage: '/images/home-categorias-recomendadas/pastas.png',
    backgroundImageAlt: 'Pastas',
  },
  {
    id: 'cat-salsas',
    title: 'SALSAS',
    backgroundColor: 'bg-gray-200',
    url: '/la-despensa-italiana/salsas',
    backgroundImage: '/images/home-categorias-recomendadas/salsas.png',
    backgroundImageAlt: 'Salsas',
  },
  {
    id: 'cat-desayunos',
    title: 'DESAYUNOS',
    backgroundColor: 'bg-gray-200',
    url: '/la-despensa-italiana/desayuno',
    backgroundImage: '/images/home-categorias-recomendadas/desayunos.png',
    backgroundImageAlt: 'Desayunos',
  },
  {
    id: 'cat-productos-cocina',
    title: 'PRODUCTOS COCINA',
    backgroundColor: 'bg-gray-200',
    url: '/limpieza-y-cuidado-del-hogar/productos-cocina',
    backgroundImage: '/images/home-categorias-recomendadas/productos-cocina.png',
    backgroundImageAlt: 'Productos Cocina',
  },
  {
    id: 'cat-dulce-chocolate',
    title: 'DULCE Y CHOCOLATE',
    backgroundColor: 'bg-gray-200',
    url: '/la-despensa-italiana/dulce-y-chocolate',
    backgroundImage: '/images/home-categorias-recomendadas/dulce-y-chocolate.png',
    backgroundImageAlt: 'Dulce y Chocolate',
  },
  {
    id: 'cat-refrescos',
    title: 'REFRESCOS',
    backgroundColor: 'bg-gray-200',
    url: '/bebidas/refrescos',
    backgroundImage: '/images/home-categorias-recomendadas/refrescos.png',
    backgroundImageAlt: 'Refrescos',
  },
  {
    id: 'cat-zumos-infantiles',
    title: 'ZUMOS INFANTILES',
    backgroundColor: 'bg-gray-200',
    url: '/alimentos-infantiles/zumos-infantiles',
    backgroundImage: '/images/home-categorias-recomendadas/zumos-infantiles.png',
    backgroundImageAlt: 'Zumos Infantiles',
  },
  {
    id: 'cat-cuidado-personal',
    title: 'CUIDADO PERSONAL',
    backgroundColor: 'bg-gray-200',
    url: '/cuidado-personal',
    backgroundImage: '/images/home-categorias-recomendadas/cuidado-personal.png',
    backgroundImageAlt: 'Cuidado Personal',
  },
];

